// extracted by mini-css-extract-plugin
export default {"promotionsBlock":"style_promotionsBlock__6q6+J","newsProdBlck":"style_newsProdBlck__-KLeh","name":"style_name__9zYrj","promImg":"style_promImg__ZPK2Y"};